<template lang="pug">
  .loading
    .blue
    //- .logo(v-html='logo')
    .wave.light-gold(v-html='wave')
    .wave.gold(v-html='wave')
    .preload-images
      img(v-for='image in images', :srcset='image.srcSet', :src='image.images[2].path')
</template>

<script>
  import {TimelineLite, Power3} from 'gsap'
  import DrawSVGPlugin from '@/assets/js/DrawSVGPlugin.js'

  export default {
    data () {
      return {
        wave: require('@/assets/img/donauhof-seperator.svg'),
        logo: require('@/assets/img/donauhof-logo.svg'),
        images: [
          require('@/assets/img/donauhof-about-image.jpg'),
          require('@/assets/img/donauhof-ballsaal-image.jpg'),
          require('@/assets/img/donauhof-co-working-image.jpg'),
          require('@/assets/img/donauhof-home-image.jpg'),
          require('@/assets/img/donauhof-cafe-image.jpg')
        ]
      }
    },
    mounted () {
      let tl = new TimelineLite({
        onCompleteScope: this,
        onComplete: function () {
          this.$parent.ready = true
        }
      })
      // wave anim
      tl.set('.wave.light-gold svg path', {stroke: '#fdfaf5'})
      // tl.set('.wave.gold svg path', {drawSVG: '0'})
      tl.to('.blue', 4, {scaleX: 0.5, ease: Power3.easeInOut}, 1)
      tl.from('.wave.gold svg path', 3, {drawSVG: '0', ease: Power3.easeInOut}, 2)
      tl.staggerFromTo('.wave svg path', 1, {drawSVG: '0 100%'}, {drawSVG: '100% 100%', ease: Power3.easeInOut}, -0.25, 5)
      tl.set('.loading, .blue', {background: 'transparent'})
    }
  }
</script>

<style lang="scss">
  @import "~utils";
  .preload-images {
    display: none;
  }
  .loading {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    background: $light-gold;
    .blue {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: $light-blue;
      transform-origin: left center;
    }
    // .logo {
    //   // width: 2.25rem;
    //   // height: 2.25rem;
    //   width: 4.6875rem;
    //   height: 4.6875rem;  
    //   position: absolute;
    //   left: 50%;
    //   top: 50%;
    //   transform: translate3d(-50%, -50%, 0);
    //   @include desktop {
        
    //   }
    //   svg {
    //     // max-height: 2.25rem;
    //     max-height: 4.6875rem;
    //     @include desktop {
          
    //     }
    //     * {
    //       // stroke: $gold !important;
    //     }
    //     path {
    //       &:first-of-type {
    //         // transform: translate3d(0, 8px, 0);
    //         // stroke: $light-gold !important;
    //         // stroke-dasharray: 10;
    //         // stroke-dashoffset: 0;
    //       }
    //       &:nth-of-type(2) {
    //         // transform: translate3d(0, -8px, 0);
    //         // opacity: 0;
    //       }
    //       &:last-of-type {
            
    //       }
    //     }
    //   }
    // }
    .wave {
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 4rem;
      height: 0.3125rem;
      // &.light-gold {
      //   opacity: .25;
      //   svg path {
      //     // stroke: $light-gold !important;
      //   }
      // }
      // &.gold {
      //   display: none;
      // }
    }
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?69254ffe